import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  newEventForm: defineAsyncComponent(() => importWithRetry(() => import('./form')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import('./store')))
